import { mapActions, mapGetters } from 'vuex'
import { scrollTo } from '@/utils/scroll'
import client from '@/client/'
import { LOCALSTORAGE_POSITION_KEY, LOCALSTORAGE_PAY_HEIGHT_KEY } from '@/config/dataMap'

/**
 *  Home.vue、PdfHome.vue使用
 */
export default {
  mounted () {
    /* eslint-disable-next-line  sonarjs/no-duplicate-string */
    const _parent = document.querySelector('.wrap_scroll')
    if (_parent) {
      this.contentShowListener()
    }
  },
  methods: {
    ...mapActions('user', [
      'refresh',
    ]),
    ...mapGetters([
      'loginStatus',
      'isDiamondMember',
      'isMember',
      'isPdfMember',
      'isPdfLifeMember',
      'isVideoVip',
      'isVideoLifeMember'
    ]),
    changePay (obj) {
      this.report({ hover: obj.idx })
    },
    loginReport ({ idx }) {
      let i = 4
      if (idx && idx !== 9) {
        i = 13
      }
      if (idx === 16) {
        i = 28
      }
      this.report({ click: i })
    },

    changeRenew (bool) {
      this.report({ click: bool ? 9 : 8 })
    },
    toXieyi () {
      this.report({ click: 10 })
    },
    changePayType (obj) {
      this.report({
        click: obj.idx + 10
      })
    },
    toTop () {
      const _parent = document.querySelector('.wrap_scroll')
      _parent.scrollTop = 0
    },
    contentShowListener () {
      const _parent = document.querySelector('.wrap_scroll')
      const _parentHeight = _parent.clientHeight
      const listenDom = document.querySelectorAll('.spread-item')
      const titleList = document.querySelectorAll('.spread-item .title')
      const positionArr = []
      for (let i = 0; i < listenDom.length; i++) {
        positionArr.push(listenDom[i].offsetTop - _parentHeight + 40)
      }
      if (_parent && positionArr.length !== 0) {
        const fn = () => {
          const scrollTop = _parent.scrollTop
          for (let i = 0; i < positionArr.length; i++) {
            if (positionArr[i] && scrollTop > positionArr[i]) {
              this.reportInterestsShow({
                contentTitle: titleList[i].textContent,
                contentIndex: i + 1
              })
              positionArr[i] = false
            }
          }
        }
        fn()
        _parent.addEventListener('scroll', () => {
          fn()
        })
      }
    },
    setScrollPosition () {
      const _parent = document.querySelector('.wrap_scroll')
      const top = _parent.scrollTop
      localStorage.setItem(LOCALSTORAGE_POSITION_KEY, top)
      // 支付模块因为是异步获取数据的, 所以页面刚渲染可能没有高度
      const height = this.getPayModuleHeight()
      localStorage.setItem(LOCALSTORAGE_PAY_HEIGHT_KEY, height)
    },
    clearScrollPosition () {
      localStorage.removeItem(LOCALSTORAGE_POSITION_KEY)
      localStorage.removeItem(LOCALSTORAGE_PAY_HEIGHT_KEY)
    },
    goToScrollPosition () {
      setTimeout(() => {
        const scrollTop = localStorage.getItem(LOCALSTORAGE_POSITION_KEY) || 0
        if (scrollTop) {
          const _parent = document.querySelector('.wrap_scroll')
          const curHeight = this.getPayModuleHeight()
          const storeHeight =
            localStorage.getItem(LOCALSTORAGE_PAY_HEIGHT_KEY) || 0

          _parent.scrollTop = scrollTop - (storeHeight - curHeight)
          this.clearScrollPosition()
        }
      }, 1000)
    },
    getPayModuleHeight () {
      let height = 0
      const payModule = this.$refs.payModule
      if (payModule && payModule.$el && payModule.$el.clientHeight) {
        height = payModule.$el.clientHeight
      }
      return height
    },
    report ({
      stay_time = 0,
      click = 0,
      hover = 0,
      sub_mode = (this.$refs.payModule &&
        this.$refs.payModule.sub_mode) ||
      0
    }) {
      let user_status = 0
      if (!this.loginStatus) {
        user_status = 3
      } else if (this.isDiamondMember || this.isMember || this.isPdfLifeMember || this.isPdfMember || this.isVideoLifeMember || this.isVideoVip) {
        user_status = 1
      } else {
        user_status = 2
      }
      client.home.REPORT.reportHomeOperate({
        main_click: click,
        main_hover: hover,
        sub_mode,
        user_login: this.loginStatus ? 1 : 2,
        user_status,
        stay_time
      })
    },
    reportInterestsShow ({ contentTitle, contentIndex }) {
      client.home.REPORT.reportHomeContentShow({
        show_content2: contentTitle,
        show_content: contentIndex,
      })
    },
    scrollToPay () {
      const className = 'new-pay'
      const _dom = document.querySelector(`.${className}`)
      const scrollTop = _dom.offsetTop
      const _parent = document.querySelector('.wrap_scroll')
      scrollTo(scrollTop, 0, _parent)
    },
  },
}
